import React, { useEffect, useState } from 'react'
import style from './cardEmployeeSmall.module.scss'
import { IEmployee, ITmpEmployee } from '../../starter/model/interfaces'
import { useDrag } from 'react-dnd'
import PersonContactSet from '../PersonContactSet/PersonContactSet'
import { EditOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { store } from '../../starter/redux/store'
import { useActions } from '../../starter/hooks/actions'
import { useDeleteEmployeeMutation, useUpdateEmployeeMutation } from '../../starter/api/employeesApi'
import CreateEmployee from '../CreateEmployee/CreateEmployee'
import { BirthDay } from '../../images/icons'
import dayjs from 'dayjs'
import { DATE_FORMAT } from '../../starter/constants'
import CardEmployeeTooltip from './CardEmployeeTooltip'
import { useAppSelector } from '../../starter/hooks/redux'

type TCardEmployee = {
  employee: IEmployee
  isFree?: boolean
}
export default function CardEmployeeSmall({ employee, isFree }: TCardEmployee) {
  const [
    updateEmployee,
    {
      isLoading: updateIsLoading,
      isSuccess: isSuccessUpdateEmployee,
      isError: isErrorUpdateEmployee,
      error: updateError
    }
  ] = useUpdateEmployeeMutation()
  const [
    deleteEmployee,
    {
      isLoading: deleteIsLoading,
      isSuccess: isSuccessDeleteEmployee,
      isError: isErrorDeleteEmployee,
      error: deleteError
    }
  ] = useDeleteEmployeeMutation()
  const { setTmpEmployee, onShowModal, setModalData, setButtonSet, setError } = useActions()
  const [isBirthday, setIsBirthday] = useState<boolean>(false)
  const [birthday, setBirthday] = useState<string>('')
  const { buttonSet } = useAppSelector((state) => state.modal)

  useEffect(() => {
    if (isErrorUpdateEmployee || isErrorDeleteEmployee) {
      setError({
        isError: true,
        // @ts-ignore
        message: (updateError && updateError.data) || (deleteError && deleteError.data)
      })
    }
  }, [isErrorUpdateEmployee, isErrorDeleteEmployee, updateError, deleteError])

  useEffect(() => {
    if (isSuccessUpdateEmployee || isSuccessDeleteEmployee) {
      onShowModal(false)
    }
  }, [isSuccessUpdateEmployee, isSuccessDeleteEmployee])

  useEffect(() => {
    setButtonSet(
      buttonSet.map((button) => ({
        ...button,
        loading: (deleteIsLoading || updateIsLoading) && button.type === 'primary'
      }))
    )
  }, [updateIsLoading, deleteIsLoading])

  useEffect(() => {
    const birthDay = dayjs(employee.birthDay)
    const day = birthDay.get('date')
    const month = birthDay.get('month')
    const year = dayjs().get('year')
    const tmpDate = dayjs(`${year}-${month + 1}-${day}`).format(DATE_FORMAT)
    const diff = dayjs(tmpDate).diff(dayjs(), 'days')
    if (diff <= 14 && diff >= 0) {
      setIsBirthday(true)
      setBirthday(`${month + 1 > 9 ? month + 1 : `0${month + 1}`}-${day > 9 ? day : `0${day}`}`)
    }
  }, [employee])

  const [, employeeRef] = useDrag({
    type: 'employee-small',
    item: employee,
    collect: (monitor) => monitor
  })

  const editEmployee = () => {
    onShowModal(true)
    const tmpEmployee = { ...(employee as ITmpEmployee) }
    tmpEmployee.validate = {
      isValid: false,
      showError: false,
      message: []
    }
    setTmpEmployee(tmpEmployee)
    setButtonSet([
      {
        type: 'primary',
        loading: deleteIsLoading,
        danger: true,
        confirm: {
          text: 'Удалить сотрудника',
          description: `Вы уверены, что хотите удалить сотрудника: ${employee.firstName} ${employee.lastName}`,
          onConfirm: () => {
            const { employee } = { ...store.getState().tmp }
            if (employee) {
              deleteEmployee(employee._id)
            }
          }
        },
        children: 'Удалить'
      },
      {
        type: 'primary',
        loading: updateIsLoading,
        onClick: () => {
          const { employee } = { ...store.getState().tmp }
          if (employee && employee.validate?.isValid) {
            updateEmployee(employee)
          } else {
            // todo что-то странное ниже
            const _employee: ITmpEmployee = JSON.parse(JSON.stringify(employee)) //{...employee}
            _employee.validate.showError = true
            setTmpEmployee(_employee)
          }
        },
        children: 'Ok'
      },
      {
        onClick: () => onShowModal(false),
        children: 'Cancel'
      }
    ])

    setModalData({
      title: 'Введите данные сотрудника',
      content: <CreateEmployee />
    })
  }
  return (
    <div className={[style.wrapper, isFree ? style.isFree : ''].join(' ')} ref={employeeRef}>
      {isBirthday && (
        <div className={style.birthday}>
          <div className={style.birthdayDate}>{birthday}</div>
          <div className={style.birthdayIcon}>
            <BirthDay />
          </div>
        </div>
      )}
      <div className={style.title}>
        <Tooltip
          overlayInnerStyle={{ width: '35rem' }}
          title={() => <CardEmployeeTooltip employee={employee} />}
          trigger={'click'}>
          <div>
            {employee.firstName} {employee.lastName}
          </div>
        </Tooltip>
        <EditOutlined
          style={{ cursor: 'pointer', zIndex: 2 }}
          onClick={() => {
            editEmployee()
          }}
        />
      </div>

      <PersonContactSet person={employee} />
    </div>
  )
}
